import { v2Api } from './v2Client';

const LOG = '[SquashAPI terrainOpeningHours]';

/** Une ligne d'horaires — toujours attachée à un terrain précis (pas de règle générique par sport). */
function normalizeHours(row) {
  if (!row) return null;
  const id = row.id ?? row.Id;
  if (id == null) return null;
  return {
    id: String(id),
    terrain_id: row.terrain_id ?? row.terrainId ?? row.TerrainId ?? null,
    day_of_week: Number(row.day_of_week ?? row.dayOfWeek ?? 0) || 0,
    opens_at: row.opens_at ?? row.opensAt ?? '08:00:00',
    closes_at: row.closes_at ?? row.closesAt ?? '22:00:00',
  };
}

/** GET /TerrainOpeningHours/list?sport= (omis = tous les sports) */
export async function listOpeningHours(sport) {
  try {
    const params = sport ? { sport } : undefined;
    const { data } = await v2Api.get('/TerrainOpeningHours/list', { params });
    const rows = Array.isArray(data) ? data : [];
    return rows.map(normalizeHours).filter(Boolean);
  } catch (err) {
    console.error(LOG, 'list échoué', { sport, err });
    throw err;
  }
}

/**
 * POST /TerrainOpeningHours/bulk_update — remplace en un coup les jours fournis pour ce terrain.
 * @param {{terrainId: string, days: {day_of_week:number, opens_at:string, closes_at:string}[]}} payload
 */
export async function bulkUpdateOpeningHours({ terrainId, days }) {
  try {
    const body = { terrain_id: terrainId, days };
    const { data } = await v2Api.post('/TerrainOpeningHours/bulk_update', body);
    const rows = Array.isArray(data) ? data : [];
    return rows.map(normalizeHours).filter(Boolean);
  } catch (err) {
    console.error(LOG, 'bulk_update échoué', { terrainId, days, err });
    throw err;
  }
}

export const terrainOpeningHoursService = {
  list: listOpeningHours,
  bulkUpdate: bulkUpdateOpeningHours,
};
